import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { canUseDOM } from 'exenv';
import Insights from '@parkwhiz-js/insights-sdk';

import CoordinatesModel from 'models/coordinates';
import HubModel from 'models/hub';
import Brand from 'models/brand';

import { PAGEVIEW_EVENT } from 'lib/analytics/events';
import * as AppContext from 'lib/app-context';
import { pageProps, urlProps } from 'lib/analytics/page-properties';

import Destinations from 'components/hub/destinations';
import HeroSearch from 'components/hub/hero-search';
import HubDescription from 'components/hub/description';
import TextToDownload from 'components/common/text-to-download';
import HowItWorks from 'components/common/how-it-works';

import initializeHub from 'action-creators/search/initialize-hub';
import cleanupHubState from 'action-creators/search/cleanup-hub-state';
import trackEventCreator from 'action-creators/analytics/track-event';
import sendAppDownloadTextCreator from 'action-creators/brand/send-app-download-text';
import scrollToTop from 'action-creators/scroll-to-top';

const propTypes = {
  hub: PropTypes.instanceOf(HubModel).isRequired,
  geoIPLocation: PropTypes.instanceOf(CoordinatesModel).isRequired,
  appContext: PropTypes.string,
  hubInitialized: PropTypes.bool.isRequired,
  sendAppDownloadText: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  insights: PropTypes.instanceOf(Insights).isRequired,
  initializeHub: PropTypes.func.isRequired,
  cleanupHubState: PropTypes.func.isRequired,
  scrollToTop: PropTypes.func.isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const defaultProps = {
  appContext: AppContext.DESKTOP,
};

class Hub extends Component {
  componentWillMount() {
    if (!this.props.hubInitialized) { this.props.initializeHub(); }
    if (canUseDOM) {
      this.props.scrollToTop();
      const { trackEvent, hub } = this.props;
      const pageProperties = pageProps({ app: 'Hub', hub });
      trackEvent({
        ...PAGEVIEW_EVENT,
        ...pageProperties,
        name: pageProperties.pageName,
        properties: {
          ...urlProps(),
          HubID: hub.id,
          HubName: hub.name,
        },
      });
    }
  }

  componentWillUnmount() {
    this.props.cleanupHubState();
  }

  render() {
    const { hub, geoIPLocation, appContext, sendAppDownloadText, brand } = this.props;

    return (
      <div className={`hub-page ${hub.heroClass}`}>
        <HeroSearch
          hub={hub}
          geoIPLocation={geoIPLocation}
          appContext={appContext}
          insights={this.props.insights}
          trackEvent={this.props.trackEvent}
          brand={brand}
        />
        <Destinations
          hub={hub}
          brand={brand}
        />
        <HubDescription hub={hub} />
        <HowItWorks brand={brand} appContext={appContext} />
        <TextToDownload
          className="margin-vertical-40"
          sendAppDownloadText={sendAppDownloadText}
          brand={this.props.brand}
        />
      </div>
    );
  }
}

Hub.propTypes = propTypes;
Hub.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  const {
    hub,
    geoIPLocation,
    hubInitialized,
  } = state.search;

  const {
    appContext,
  } = state.app;

  const {
    insights,
  } = state.analytics;

  const { brand } = state.brand;

  return {
    hub,
    geoIPLocation,
    appContext,
    insights,
    hubInitialized,
    brand,
  };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    trackEvent: trackEventCreator,
    sendAppDownloadText: sendAppDownloadTextCreator,
    initializeHub,
    cleanupHubState,
    scrollToTop,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Hub);
